import { jsPDF } from "jspdf";
import { PROPERTY, AGENT } from "@/data/property";

export function downloadBrochure() {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const M = 48;
  const W = 595;

  doc.setFillColor(11, 12, 14);
  doc.rect(0, 0, W, 118, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(30);
  doc.text("461 BEECHWOOD", M, 68);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(184, 142, 98);
  doc.text("CONDOMINIUM TOWNHOUSE — WATERLOO, ONTARIO", M, 90);

  doc.setTextColor(24, 24, 27);
  doc.setFontSize(12);
  doc.text(PROPERTY.address, M, 152);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.text("$399,900", M, 186);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  const specLines = [
    `${PROPERTY.specs.bedrooms} bedrooms  ·  ${PROPERTY.specs.bathrooms} bathrooms  ·  ${PROPERTY.specs.type}`,
    `Exterior area 1,077 sq ft across three levels  ·  Property taxes (2026): ${PROPERTY.specs.taxes.replace(" (2026)", "")}`,
  ];
  doc.text(specLines, M, 216);

  doc.setDrawColor(228, 228, 231);
  doc.line(M, 244, W - M, 244);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("THE RESIDENCE", M, 272);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10.5);
  doc.text(doc.splitTextToSize(PROPERTY.description, W - 2 * M), M, 292);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("HIGHLIGHTS", M, 360);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10.5);
  const feats = [
    "Two-bedroom condominium townhouse in Waterloo's Beechwood community",
    "One and a half bathrooms",
    "Official iGuide virtual walkthrough online",
    "2026 property taxes: $2,606.72",
  ];
  doc.text(feats.map((f) => "–  " + f), M, 384);

  doc.setFillColor(244, 244, 243);
  doc.rect(M, 470, W - 2 * M, 76, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("SHAWN RAMAUTOR", M + 20, 498);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`${AGENT.title} · ${AGENT.brokerage}`, M + 20, 516);
  doc.setFontSize(9);
  doc.text(`${AGENT.phone}  ·  ${AGENT.email}  ·  Private showings by appointment only`, M + 20, 532);

  doc.save("461-beechwood-brochure.pdf");
}
